package com.essntl.uikit.components.card

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun CardInfo(
    title: String,
    information: String,
    informationColor: Color = Color.White,
    action: @Composable () -> Unit = {},
) {
    Box(
        modifier = Modifier
            .width(264.dp)
            .height(108.dp)
            .background(
                color = MaterialTheme.esColorScheme.tinted,
                shape = RoundedCornerShape(size = 2.spacing),
            )
            .border(
                width = 1.dp,
                color = MaterialTheme.esColorScheme.borderPrimary,
                shape = RoundedCornerShape(size = 2.spacing),
            )
            .padding(1.5.spacing),
    ) {
        Row {
            SelectionContainer {
                Text(
                    text = title,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    style = MaterialTheme.esTypography.p1Regular16,
                    modifier = Modifier.fillMaxWidth(0.7f)
                )

            }
            Spacer(modifier = Modifier.weight(1f))

            action()
        }

        Box(
            modifier = Modifier
                .width(264.dp)
                .height(40.dp)
                .background(informationColor, shape = RoundedCornerShape(size = 2.spacing))
                .align(Alignment.BottomCenter)
                .padding(horizontal = 2.spacing, vertical = 1.spacing),
        ) {
            SelectionContainer {
                Text(
                    text = information,
                    style = MaterialTheme.esTypography.p1Medium16,
                    modifier = Modifier.align(Alignment.CenterStart),
                )
            }
        }
    }
}